'use client'

import { useDashboardStats, useCurrentUser, useWeeklyTime } from '@/hooks/use-dashboard'
import { useAuth } from '@/lib/stores/auth-store'
import { OrbitFlowDashboard } from '@/components/dashboard/orbitflow-dashboard'

export default function HomePage() {
  const { data: stats, isLoading } = useDashboardStats()
  const { data: currentUser } = useCurrentUser()
  const { data: weeklyTime = [] } = useWeeklyTime()
  const { user } = useAuth()

  return (
    <OrbitFlowDashboard
      stats={stats}
      user={currentUser || user}
      weeklyTime={weeklyTime}
      loading={isLoading}
    />
  )
}
